import { Model, YardTrip } from ".";

export default class Truck extends Model {
	get singularNoun() {
		return "truck";
	}

	get mutations() {
		return {
			activeTrip: YardTrip,
			trips: YardTrip
		};
	}

	resource() {
		return "yard/trucks";
	}
}
